import React from 'react'
import styled from 'styled-components'

export default styled.div`
  font-family: "Adelle Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  color: #606060;
`